import * as React from 'react';
import { ActivitySchedule } from '../../../model/activities';
import { Typography, Grid, Dialog, DialogTitle, DialogContent } from '@material-ui/core';
import Button from '../../Button/Button';
import { SearchBoxApi } from '../../SearchBoxApi/SearchBoxApi';
import { contact } from '../../../model/contact';
import { invokeApi } from '../../../common/networking/invoker';
import ConfirmButton from '../../Button/ConfirmButton';
import UndoButton from '../../Button/UndoButton';

interface IProps {
    schedule: ActivitySchedule;
    addReservation: (contact: contact, schedule: ActivitySchedule) => any;
    classes: any;
}


const templateSearchBoxContact = (contact?: contact) => {
    return contact ? {
        label: (contact.surname ? contact.surname + " " + contact.name + " - " : "") + contact.email,
        value: contact
    } : undefined;
}

const searchContactsSearchBox = (search: string, take?: number): Promise<Array<contact>> => {
    // console.log("searchContactsSearchBox", search, take); 
    return new Promise((resolve, reject) => {
        invokeApi({
            path: take ? `/api/Contacts?fullnameOrEmail=${search}&take=${take}`
                : `api/Contacts?fullnameOrEmail=${search}`,
            method: 'GET',
            responseType: "json",
        }).then(val => {
            resolve(val);
        }).catch(val => {
            reject(val)
        })
    })
}

export const ReservationsHeader = (props: IProps) => {
    const [dialog, setDialog] = React.useState(false);
    const [user, setUser] = React.useState<contact>();
    const addReservation = () => {
        props.addReservation(user, props.schedule);
        setDialog(false);
    }
    React.useEffect(() => {
        setUser(undefined);
    }, [dialog]);
    const canAddUser = () => {
        if (!user) return false;
        return (props.schedule.reservations || []).findIndex(a => a.sub === user.sub) > -1;
    }
    return <Grid container className={props.classes.reservationDialogHeader}>
        <Grid item sm={6}>
            <Typography>Posti liberi: {props.schedule.capacity - (props.schedule?.reservations?.length || 0)}/{props.schedule.capacity}</Typography>
        </Grid>
        <Grid item sm={6}>
            <Button onClick={() => { setDialog(true) }}>Aggiungi prenotazione</Button>
        </Grid>
        <Dialog open={dialog} onClose={(e) => setDialog(false)} classes={{ paper: props.classes.addReservationDialog }}>
            <DialogTitle>Seleziona utente</DialogTitle>
            <DialogContent className={props.classes.reservationSlotDetailDialogContent}>
                <Grid item xs={12} style={{ margin: "5px" }}>
                    <SearchBoxApi<contact>
                        selectedItem={user}
                        openOnFocus
                        doFilter
                        listSize={10}
                        getItems={searchContactsSearchBox}
                        label={"Utente"}
                        placeholder={"Digitare cognome o nome"}
                        templateItem={templateSearchBoxContact}
                        onSelectedChange={(item) => { console.log("Setuser", item); setUser(item); }} />
                </Grid>
                <Grid item sm={12} className={props.classes.reservationSlotDetailDialogButtons}>
                    <ConfirmButton className={props.classes.reservationSlotDetailDialogButton} disabled={canAddUser()} onClick={addReservation} text={'Aggiungi'} />
                    <UndoButton className={props.classes.reservationSlotDetailDialogButton} onClick={() => { setDialog(false) }} text={'Annulla'} />
                </Grid>
            </DialogContent>
        </Dialog>
    </Grid>
}